export default __webpack_public_path__ + "static/SR France - ISO 14001 - Certificate-526612678d3fcea698518977c76d18e7.pdf";